// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e74dc064","396":"477abb4f","453":"8137b8c2","667":"8125bcef","789":"3c609e8d","977":"deb43d34"}[chunkId] + ".chunk.js";
};